<template>
  <form :ref="customizeWhitelabelFormRef" method="POST">
    <input
      type="hidden"
      name="__RequestVerificationToken"
      :value="antiforgeryToken"
    />
    <div class="row">
      <div class="column small-12">
        <p class="mbm">
          {{ unPrettierNuggets.blurb }}
        </p>
        <label for="whitelabel-text">
          <strong class="text-black">Texte Whitelabel</strong>
        </label>
        <span>Texte en marque blanche sur les images</span>
        <img
          :ref="whitelabelTextTooltipRef"
          class="has-tip top mls"
          data-tooltip
          aria-haspopup="true"
          data-allow-html="true"
          data-tooltip-class="tooltip"
          :src="questionIconUrl"
          alt="question mark icon"
          title="<strong class='text-black'>Texte Whitelabel</strong>
            <br />
            Il s'agit du texte rendu en filigrane sur les images ainsi que de la marque pour les PDF et les pages client. Pour de meilleurs résultats, nous vous recommandons de limiter le texte à 15 à 25 caractères.
            <br />
            Exemple: <em>Exemple de mon entreprise</em>"
        />
        <input
          id="whitelabel-text"
          v-model="whiteLabelTextValue"
          type="text"
          name="Text"
        />

        <label for="whitelabel-logo-url">
          <strong class="text-black">Votre logo (URL de l'image)</strong>
        </label>
        <span>
          {{ unPrettierNuggets.logoBlurb }}
        </span>
        <img
          :ref="whitelabelImageTooltipRef"
          class="has-tip right"
          data-tooltip
          aria-haspopup="true"
          data-allow-html="true"
          data-tooltip-class="tooltip"
          :src="questionIconUrl"
          alt="question mark icon"
          title="<strong class='text-black'>Whitelabel Image</strong>
            <br />
            Il s'agit du lien vers l'emplacement de votre image pour votre logo. Pour de meilleurs résultats, nous recommandons un logo de 250 pixels de large sur 150 pixels de haut.
            <br />
            Si vous avez un logo sur votre site Web que vous souhaitez utiliser, faites un clic droit sur l'image, puis cliquez sur Propriétés. Vous verrez alors l'URL que vous pouvez copier et coller ici.
            <br />Exemple: <em>http://www.example.com/mylogo.jpg</em>"
        />
        <input
          id="whitelabel-logo-url"
          v-model="whiteLabelImageUrlValue"
          type="text"
          name="ImageUrl"
        />
        <img
          v-if="whitelabelImageUrl"
          class="mbm"
          :src="whitelabelImageUrl"
          alt="whitelabel logo preview"
        />
      </div>
    </div>
    <div class="row align-center form-stacking form-stacking--medium">
      <div class="column small-12">
        <hr class="horizontal-rule horizontal-rule--form-frame-small mbm" />
      </div>
      <div class="column small-12 large-shrink">
        <button
          class="form-stacking__item button primary full-width"
          @click="onClickSaveDetails"
        >
          Enregistrez les informations
        </button>
      </div>
      <div class="column small-12 large-shrink">
        <button
          class="form-stacking__item button secondary hollow full-width"
          @click="onClickSaveDetailsAndPreviewPdf"
        >
          Sauvegarder & Voir le PDF
        </button>
      </div>
      <div class="column medium-12 large-shrink">
        <button
          class="button secondary hollow full-width mbn"
          @click="onClickSaveDetailsAndPreviewClientPortal"
        >
          Sauvegarder & Voir le Portail Client
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    questionIconUrl: {
      type: String,
      default: '',
    },
    whitelabelText: {
      type: String,
      default: undefined,
    },
    whitelabelImageUrl: {
      type: String,
      default: undefined,
    },
    saveDetailsApi: {
      type: String,
      default: undefined,
    },
    saveDetailsPreviewPdfApi: {
      type: String,
      default: undefined,
    },
    saveDetailsPreviewClientPortalApi: {
      type: String,
      default: undefined,
    },
    antiforgeryToken: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      customizeWhitelabelFormRef: 'js-customize-whitelabel-form',
      whiteLabelTextValue: this.whitelabelText,
      whiteLabelImageUrlValue: this.whitelabelImageUrl,
      whitelabelTextTooltip: null,
      whitelabelImageTooltip: null,
      whitelabelTextTooltipRef: 'js-whitelabel-text-tooltip',
      whitelabelImageTooltipRef: 'js-whitelabel-image-tooltip',
      unPrettierNuggets: {
        blurb: `Cette page vous permet de personnaliser l'image de marque du portail client et des fichiers PDF générés lorsque vous les partagez avec vos clients. En faisant cela, vous pouvez faire en sorte que la sortie générée ressemble à la vôtre.`,
        logoBlurb: `Image qui s'affiche comme votre logo sur le Portail et PDF (Taille recommandée : largeur 300px et hauteur 100px)`,
      },
    };
  },
  mounted() {
    if (window.Foundation && window.$) {
      this.whitelabelTextTooltip = new window.Foundation.Tooltip(
        // eslint-disable-next-line no-undef
        $(this.$refs[this.whitelabelTextTooltipRef]),
      );

      this.whitelabelImageTooltip = new window.Foundation.Tooltip(
        // eslint-disable-next-line no-undef
        $(this.$refs[this.whitelabelImageTooltipRef]),
      );
    }
  },
  methods: {
    onClickSaveDetails(event) {
      event.preventDefault();
      this.$refs[this.customizeWhitelabelFormRef].action = this.saveDetailsApi;
      this.$refs[this.customizeWhitelabelFormRef].submit();
    },
    onClickSaveDetailsAndPreviewPdf(event) {
      event.preventDefault();
      this.$refs[this.customizeWhitelabelFormRef].action =
        this.saveDetailsPreviewPdfApi;
      this.$refs[this.customizeWhitelabelFormRef].submit();
    },
    onClickSaveDetailsAndPreviewClientPortal(event) {
      event.preventDefault();
      this.$refs[this.customizeWhitelabelFormRef].action =
        this.saveDetailsPreviewClientPortalApi;
      this.$refs[this.customizeWhitelabelFormRef].submit();
    },
  },
};
</script>
